import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from 'taxtank-core';
import { DateTime } from 'luxon';

/**
 * Custom date pipe
 */
@Pipe({
  name: 'zonedDate',
  standalone: false
})
export class ZonedDatePipe implements PipeTransform {
  timezone = this.userService.getCacheFirst().clientDetails?.timezone;
  constructor(private userService: UserService) {}

  transform(value: string | Date, format = 'dd.MM.yy'): any {
    if (!value) {
      return value;
    }

    let dateTime = typeof value === 'string' ? DateTime.fromISO(value) : DateTime.fromJSDate(value);
    if (this.timezone) {
      dateTime = dateTime.setZone(this.timezone);
    }

    return dateTime.toFormat(format);
  }
}
